export default "__VITE_ASSET__b6634431__"